import BaseApi from 'api/base';
import { TRACK_EVENT_URL_V2 } from 'api/constants';
import { loadSessionId } from 'utils/tokenStorage';
import { Config } from 'utils/config/config';

export const generateRequiredProperties = () => ({
  client: 'web',
  actorContext: 'Staff',
  eventVersion: 2,
  eventTime: +new Date(),
  sessionId: loadSessionId() || null,
  userAgent: window.navigator.userAgent,
});

export const trackEventAsync = (
  eventObject: ITrackingEventV2Type,
): Promise<void> => {
  return Config.SHOULD_TRACK_MAMI_EVENTS === 'false' &&
    Config.NODE_ENV === 'development'
    ? Promise.resolve()
    : BaseApi.authRequest(TRACK_EVENT_URL_V2(), {
        method: 'POST',
        body: JSON.stringify(eventObject),
      });
};
